import { Trans } from '@lingui/macro';
import _ from 'lodash';

import FixedLabelContainer, { Row, Label, Content, Line } from '../../fixed-label-container/FixedLabelContainer';

import StatusBreakoutRow from '../../status-breakout/StatusBreakoutRow';
import StatusBreakout from '../../charts/status-breakout/StatusBreakout';
import { convertStatusToStatusCounts } from '../../charts/data-series';
import { useBusinessService } from '../../filters';

const present = (data, metric) => {
    const counts = data?.[metric];
    return counts?.total;
};

const empty = { trends: { status: { data: [] } } };

export default function BusinessServiceDetail({ statusCounts, onTimeRangeChange = _.noop }) {
    const bs = useBusinessService();
    const statusData = statusCounts?.data?.[0];

    const overAllCounts = statusData ? convertStatusToStatusCounts('status', statusData) : empty;
    const clearTimeRange = statusData === undefined;
    const height = clearTimeRange ? 30 : 20;

    let last = '';
    if (present(statusData, 'bsDeviceCounts')) last = 'bsDeviceCounts';
    else if (present(statusData, 'bsServerCounts')) last = 'bsServerCounts';
    else if (present(statusData, 'bsTestCounts')) last = 'bsTestCounts';

    return (
        <FixedLabelContainer>
            <Row>
                <Label>
                    <Trans>Overall Status</Trans>
                </Label>
                <Content>
                    <StatusBreakout
                        height={height}
                        disableTimeAxis
                        metricName="status"
                        data={overAllCounts}
                        onTimeRangeChange={onTimeRangeChange}
                        clearTimeRange={clearTimeRange}
                        isStatus
                    />
                </Content>
            </Row>
            <Line />
            <StatusBreakoutRow
                page="/tests"
                title={<Trans>Service Tests</Trans>}
                metric="bsTestCounts"
                data={statusData}
                last={last}
                entityType="businessservice"
                entityUuid={bs?.uuid}
            />
            <StatusBreakoutRow
                page="/servers"
                title={<Trans>Servers</Trans>}
                metric="bsServerCounts"
                data={statusData}
                last={last}
                entityType="businessservice"
                entityUuid={bs?.uuid}
            />
            <StatusBreakoutRow
                page="/network-devices"
                title={<Trans>Network Devices</Trans>}
                metric="bsDeviceCounts"
                data={statusData}
                last={last}
                entityType="businessservice"
                entityUuid={bs?.uuid}
            />
        </FixedLabelContainer>
    );
}
